import { RecentlyViewed } from '@theme/recently-viewed-products';
const recentlyViewedProducts = RecentlyViewed.getProductsForPage();
const container = document.querySelector('#recently-viewed-products');

if (container && recentlyViewedProducts.length) {

  // Fetch all product data in parallel, then render in order
  Promise.all(
    recentlyViewedProducts.map((item) => {
      const js = `https://${window.Shopify.shop}/products/${item.handle}.js`;
      return fetch(js)
        .then(response => response.json())
        .then(product => ({ item, product }))
        .catch(() => null); // handle fetch errors gracefully
    })
  ).then(results => {    
    results.forEach((result, index) => {
      if (!result) return;
      const { item, product } = result;
      // Create product card
      const productCard = document.createElement('div');
      productCard.className = 'recently-viewed-product-card';

      // Create product link
      const productLink = document.createElement('a');
      productLink.href = `/products/${item.handle}`;
      productLink.className = 'recently-viewed-link';

      // Create product image
      const productImage = document.createElement('img');
      productImage.src = product.featured_image;
      productImage.alt = product.title;
      productImage.className = 'recently-viewed-image';

      // Create marketing title
      const marketingTitle = document.createElement('p');
      marketingTitle.innerHTML = `<strong>${item.marketing_title}</strong>`;
      marketingTitle.className = 'recently-viewed-marketing-title';

      // Create product title
      const title = document.createElement('p');
      title.innerHTML = item.country_of_origin
        ? `${product.title} / ${item.country_of_origin}`
        : `${product.title}`;
      title.className = 'recently-viewed-product-title';

      // Create price element if price_per_yard exists
      let price;
      if (item.price_per_yard) {
        price = document.createElement('p');
        price.innerHTML = `<span>Price per yard:</span><br>$${item.price_per_yard} USD`;
        price.className = 'recently-viewed-price';
      }

      // Append elements
      productLink.append(productImage, marketingTitle, title);
      if (price) productLink.appendChild(price);
      productCard.appendChild(productLink);
      container.appendChild(productCard);
    });
  });
}

